import { render, staticRenderFns } from "./SelectAnoSemestreCicloComponent.vue?vue&type=template&id=2733b54c&scoped=true&"
import script from "./SelectAnoSemestreCicloComponent.vue?vue&type=script&lang=js&"
export * from "./SelectAnoSemestreCicloComponent.vue?vue&type=script&lang=js&"
import style0 from "./SelectAnoSemestreCicloComponent.vue?vue&type=style&index=0&id=2733b54c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2733b54c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
